import styled from 'styled-components';

export const SWrapper = styled.div<{ isPremium: boolean }>`
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 2rem;
    cursor: ${({ isPremium }) => (isPremium ? 'default' : 'pointer')};
`;
